<template>
  <main class="app-content">
    <div class="app-title">
      <div>
        <h1>
          <font-awesome-icon icon="ban"/>
          {{ $t('title') }}
        </h1>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="tile">
          <div class="form-inline">
            <b-form-input class="mr-1 mb-1" v-model="filterFormModel.keyword" v-on:keydown.enter="load"
                          :placeholder="$t('keyword')"></b-form-input>
            <button @click="load" class="btn btn-primary mr-1 mb-1">{{ $t('search') }}</button>
            <button @click="reset" class="btn btn-secondary mr-1 mb-1">Reset</button>
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="c-sorting" v-if="['admin', 'owner', 'tech'].includes($store.state.user.role)">
          <div class="row">
            <div class="col-lg-12 c-sorting__right">
              <div class="c-sorting__btn">
                <d-n-c-import></d-n-c-import>
                <button @click="create" class="btn btn-sm btn-success">
                  <font-awesome-icon icon="plus"/>&nbsp;{{ $t('create') }}
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="c-paging clearfix">
          <div class="c-paging__count" v-if="itemCount">
            {{ $t('found', [itemCount]) }}
          </div>
          <div class="c-paging__right">
            <div class="c-paging__numbers">
              <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" size="sm"
                            v-model="filterFormModel.page" :total-rows="itemCount"
                            :per-page="filterFormModel.pageSize" @input="load"></b-pagination>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12" v-if="items.length">
        <div class="c-smart-table tile">
          <div class="row c-smart-table__title">
            <div class="col-lg-2">{{ $t('phone') }}</div>
            <div class="col-lg-3">{{ $t('desc') }}</div>
            <div class="col-lg-1">{{ $t('status') }}</div>
            <div class="col-lg-3">{{ $t('time') }}</div>
            <div class="col-lg-2"></div>
          </div>
          <div class="row" v-for="item in items" :key="item._id">
            <div class="col-lg-2">
              <b class="c-smart-table__label">{{ $t('phone') }}: </b>
              <span>{{ item.phone }}</span>
            </div>
            <div class="col-lg-3">
              <b class="c-smart-table__label">{{ $t('desc') }}: </b>
              <span v-if="item.desc">{{ item.desc }}</span>
              <span v-else class="text-secondary">{{$t('notUpdated')}}</span>
            </div>
            <div class="col-lg-1">
              <p>
                <label v-if="item.active" class="badge badge-danger">DNC</label>
                <label v-else class="badge badge-success">{{ $t('allowToCall') }}</label>
              </p>
            </div>
            <div class="col-lg-3">
              <p>
                <b>{{ $t('createTime') }}: </b>
                <span>{{ item.createTime | moment('DD/MM/YYYY HH:mm:ss')}}</span>
              </p>
              <p>
                <b>{{ $t('updateTime') }}: </b>
                <span>{{ item.updateTime | moment('DD/MM/YYYY HH:mm:ss')}}</span>
              </p>
            </div>
            <div class="col-lg-2">
              <div class="c-smart-table__content">
                <div class="c-buttons clearfix is-2">
                  <div class="c-buttons__col" v-if="['admin', 'owner', 'tech'].includes($store.state.user.role)">
                    <button @click="update(item._id)" type="button"
                            class="btn btn-sm btn-info mr-1">
                      <font-awesome-icon icon="edit"/>&nbsp;{{ $t('edit') }}
                    </button>
                    <button @click="del(item._id)" type="button" class="btn btn-sm btn-danger mr-1">
                      <font-awesome-icon icon="trash"/>&nbsp;{{ $t('delete') }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 text-center text-danger" v-if="!items.length">
        <span v-if="filterFormModel.page === 1 && !filterFormModel.keyword">{{ $t('notFoundCreate') }}</span>
        <span v-if="filterFormModel.page > 1 || filterFormModel.keyword">{{ $t('notFoundSearch') }}</span>
      </div>
      <div class="col-12" v-if="itemCount">
        <div class="c-paging__count" v-if="itemCount">
          {{ $t('found', [itemCount]) }}
        </div>
        <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" size="sm"
                      v-model="filterFormModel.page" :total-rows="itemCount" :per-page="filterFormModel.pageSize"
                      @input="load">
        </b-pagination>
      </div>
    </div>
    <b-modal v-model="showForm" :title="formTitle" @ok="save" no-close-on-backdrop no-enforce-focus>
      <form-input :label="$t('phone')" :model="formModel" attribute="phone" :errors="formErrors"></form-input>
      <form-input :label="$t('desc')" :model="formModel" attribute="desc" :errors="formErrors">
      </form-input>
      <form-checkbox :chk-label="$t('active')" :model="formModel" attribute="active" :errors="formErrors"></form-checkbox>
    </b-modal>
  </main>
</template>
<script>
import List from '../../mixins/List';
import CRUD from "../../mixins/CRUD";
import DNCImport from "./DNCImport";

export default {
  mixins: [List, CRUD],
  components: {DNCImport},
  data: function () {
    return {
      service: '/dnc',
      defaultFormModel: {
        active: true
      },
      autoLoad: true
    }
  },
  mounted() {
    this.$bus.$on('reloadDNCList', this.load);
  },
  beforeDestroy: function () {
    this.$bus.$off('reloadDNCList');
  },
  i18n: {
    messages: {
      en: {
        title: 'Do-not-call number list',
        createTime: 'Create time',
        updateTime: 'Update time',
        active: 'Do not call',
        allowToCall: 'Allow to call',
        notUpdated: 'Not updated'
      },
      vi: {
        title: 'Danh sách DNC',
        createTime: 'Tạo lúc',
        updateTime: 'Cập nhật lúc',
        active: 'Không gọi',
        allowToCall: 'Cho phép gọi',
        notUpdated: 'Chưa cập nhật'
      }
    }
  },
}
</script>